<template>
  <div class="row">
    <div class="col-md-9">
      <div class="card card-default">
        <service-wizard-layout
          title=""
          subtitle=""
          :parts="parts"
          :onComplete="onComplete"
          :validateStep="validateStep"
        >
          <template slot="callvault">
            <form novalidate data-vv-scope="callvault">
              <div class="row">
                <div class="col-xl-8 col-lg-12">
                  <div
                    class="form-group"
                    :class="{
                      'has-error': errors.has('callvault.description'),
                    }"
                  >
                    <label>Description:</label>
                    <input
                      type="text"
                      class="form-control"
                      v-validate="'required'"
                      name="description"
                      placeholder="Call Vault Description"
                      v-model="filledInSaleDefinition.requiredObjs.callvault.description"
                    />
                    <span class="has-error" v-if="errors.has('callvault.description')">{{
                      errors.first("callvault.description")
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-8 col-lg-12">
                  <div
                    class="form-group"
                    :class="{
                    'has-error': errors.has('callvault.callCabinetPackageNumber'),
                    }"
                  >
                    <label>Package:</label>
                    <v-select
                    name="callCabinetPackageNumber"
                    placeholder="Select Package"
                    :value="packageLabel"
                    :options="packageOptions"
                    :disabled="packageOptions.length == 1"
                    @input="changePackage"
                    >
                    </v-select>
                    <span class="has-error" v-if="errors.has('callvault.callCabinetPackageNumber')">{{
                    errors.first("callvault.callCabinetPackageNumber")
                    }}</span>
                  </div>
                </div>
              </div>
            </form>
          </template>
        </service-wizard-layout>
      </div>
    </div>
  </div>
</template>

<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import ServiceWizardLayout from "@/layouts/ServiceWizardLayout";
import DateInput from "@/components/GeneralComponents/InputControls/DateInput";

export default {
  components: {
    ServiceWizardLayout,
    DateInput,
  },
  props: {
    emptySaleDefinition: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      parts: [
        {
          name: "callvault",
          displayName: "Call Vault",
          icon: "fa fa-cubes",
        },
      ],
      filledInSaleDefinition: {
        requiredObjs: {
            callvault: {},
        },
        selectableOptions: {

        }
      },
      packageOptions: [],
      packageLabel: '',
    };
  },
  mounted() {
    this.filledInSaleDefinition = this.emptySaleDefinition;
      
    //if there is a sku, then filter out all but the pre-selected objKey
    if (this.$route.query.sku) {
      let preSelectedObjKey = this.$route.query.sku.split('-',3)[2];
      var onlyOne =  this.emptySaleDefinition.selectableOptions.recordingPackage.filter( pack => pack.callCabinetPackageNumber == preSelectedObjKey);
      if (onlyOne.length == 1) {
        this.packageOptions = [];
        this.packageOptions[0] = onlyOne[0];
        this.packageLabel = onlyOne[0].description; 
        this.changePackage(onlyOne[0].description); 
      }
    } else {
      for (let i = 0; i < this.filledInSaleDefinition.selectableOptions.recordingPackage.length; i++) {
        if (this.filledInSaleDefinition.selectableOptions.recordingPackage.length > 0 && i == 0) {
          this.packageLabel = this.filledInSaleDefinition.selectableOptions.recordingPackage[i].description;
          this.filledInSaleDefinition.requiredObjs.callvault.callCabinetPackageNumber = this.filledInSaleDefinition.selectableOptions.recordingPackage[i].callCabinetPackageNumber;
        }
        this.packageOptions[i] = this.filledInSaleDefinition.selectableOptions.recordingPackage[i].description;
      }
    }
  },
  methods: {
    onComplete() {
      this.$emit("createSale", this.filledInSaleDefinition);
    },
    changePackage(value) {
        for (let i = 0; i < this.filledInSaleDefinition.selectableOptions.recordingPackage.length; i++) {
            if (value == this.filledInSaleDefinition.selectableOptions.recordingPackage[i].description) {
                this.filledInSaleDefinition.requiredObjs.callvault.callCabinetPackageNumber = this.filledInSaleDefinition.selectableOptions.recordingPackage[i].callCabinetPackageNumber;
            }
        }
    },
    validateStep(scope) {
      return this.$validator.validateAll(scope).then((result) => {
        if (result) {
          return true;
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style>
</style>